import { render, staticRenderFns } from "./OrderCrud.vue?vue&type=template&id=518b11ec&"
import script from "./OrderCrud.vue?vue&type=script&lang=js&"
export * from "./OrderCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports